import {
  Controller,
  ControllerProps,
  FieldPath,
  FieldValues,
  PathValue,
  UseFormSetValue,
} from 'react-hook-form'
import { Checkbox, CheckboxProps } from './checkbox'

type CheckboxRhfProps<TValues extends FieldValues, TName extends FieldPath<TValues>> = Omit<
  CheckboxProps,
  'value' | 'onChange'
> &
  Omit<ControllerProps<TValues, TName>, 'render'> & {
    setValue: UseFormSetValue<TValues>
    afterChange?: (value: PathValue<TValues, TName>) => void
  }

export default function CheckboxRhf<TValues extends FieldValues, TName extends FieldPath<TValues>>({
  control,
  name,
  rules,
  setValue,
  afterChange,
  ...restProps
}: CheckboxRhfProps<TValues, TName>) {
  const handleChange = (value: boolean) => {
    const typedValue = value as PathValue<TValues, TName>
    setValue(name, typedValue)
    afterChange?.(typedValue)
  }

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field }) => (
        <Checkbox {...restProps} value={field.value} onChange={handleChange} />
      )}
    />
  )
}
